import { Sprite, Texture } from 'pixi.js';
import { Tween, Easing } from '@tweenjs/tween.js';
import Button from './Button.js';
import HELPERS from '../lib/globals/helpers/Helpers.js';
import { isDesktop } from 'react-device-detect';

class SpinButton extends Button {
	constructor(obj) {
		super(obj);
		this.obj = obj;
		this.interactive = true;
		// this.buttonMode = "on";
		this.enabled = false;
		this.spin = true;
		this.sortableChildren = true;
		// obj.cursor = 'pointer'
		if (this.obj.bg) {
			this.bg = Sprite.from(Texture.from(obj.bg));
			this.addChild(this.bg);
			this.bg.anchor.set(0.5);
			this.bg.x = 0;
			this.bg.y = 0;
			this.bg.zIndex = 1;
			this.bg.sortableChildren = true;
		}
		if (this.obj.bg_icon) {
			this.bg_icon = Sprite.from(Texture.from(obj.bg_icon));
			this.bg.addChild(this.bg_icon);
			this.bg_icon.anchor.set(0.5);
			this.bg_icon.position.set(0);
			this.bg_icon.zIndex = 10;
			this.bg_icon.alpha = 1;
		}
		if (this.obj.fg_icon) {
			this.fg_icon = Sprite.from(Texture.from(obj.fg_icon));
			this.bg.addChild(this.fg_icon);
			this.fg_icon.anchor.set(0.5);
			this.fg_icon.position.set(0);
			this.fg_icon.zIndex = 10;
			this.fg_icon.alpha = 0;
		}
		if (obj.animation) {
			this.animation = HELPERS.getAnimatedSprite(obj.animation);
			this.animation.anchor.set(0.5);
			// this.animation.position.x = 5;
			// this.animation.position.y = 3;
			if (isDesktop) {
				this.animation.scale.set(1);
			} else {
				this.animation.scale.set(2);
			}
			this.bg.addChild(this.animation);
			this.animation.zIndex = 2;
			this.animation.visible = false;
		}
		this.init();
		if (window.isMobile || window.isTablet) {
			this.on('touchstart', this.mouseDown.bind(this));
			this.on('touchend', this.mouseDown.bind(this));
			this.on('touchcancel', this.mouseUp.bind(this));
			this.on('touchendoutside', this.mouseUp.bind(this));
		} else {
			this.on('keydown', this.mouseDown.bind(this));
			this.on('mousedown', this.mouseDown.bind(this));
			this.on('mouseup', this.mouseUp.bind(this));
			this.on('mouseupoutside', this.mouseUp.bind(this));
		}
	}

	init() {
		this.alpha = 0;
		if (!this.tweenInit || !this.tweenInit.isPlaying()) {
			this.tweenInit = new Tween(this)
				.to({ alpha: 1 }, 400)
				.easing(Easing.Linear.None)
				.onComplete(() => {
					this.enabled = true;
				})
				.start();
		}
	}

	mouseDown() {
		if (!this.enabled) return;
		setTimeout(() => {
			if (!this.tweenIconDown || !this.tweenIconDown.isPlaying()) {
				this.tweenIconDown = new Tween(this.bg.scale)
					.to({ y: 0.9, x: 0.9 }, 50)
					.easing(Easing.Linear.None)
					.start();
			}
		}, 0);
	}

	mouseUp() {
		setTimeout(() => {
			//   const icon = this.spin ? this.bg_icon : this.fg_icon;
			if (!this.tweenIcon || !this.tweenIcon.isPlaying()) {
				this.tweenIconDown = new Tween(this.bg.scale)
					.to({ y: 1, x: 1 }, 50)
					.easing(Easing.Linear.None)
					.start();
			}
		}, 0);
	}

	showStop() {
		this.spin = false;
		this.bg_icon.alpha = 0;
		// this.fg_icon.alpha = 1;
		this.animation.visible = true;
		this.animation.gotoAndPlay(0);
	}

	pressSpinButton() {
		if (this.enabled) {
			if (!this.tweener || !this.tweener.isPlaying()) {
				this.spin = false;
				window.sm.play({ name: 'press_click_sfx' });
				this.tweener = new Tween(this.bg_icon)
					.to({ alpha: 1, rotation: 1 }, 50)
					.easing(Easing.Sinusoidal.InOut)
					.start()
					.onComplete(() => {
						this.tweener = new Tween(this.bg_icon)
							.to({ alpha: 0 }, 50)
							.easing(Easing.Sinusoidal.InOut)
							.start();
						// this.tweener = new Tween(this.fg_icon)
						//   .to({ alpha: 1, rotation: 0 }, 50)
						//   .easing(Easing.Sinusoidal.InOut)
						//   .start();
						this.animation.visible = true;
						this.animation.gotoAndPlay(0);
					});
			}
		}
	}

	pressStopButton() {
		if (this.enabled) {
			if (!this.tweenerStop || !this.tweenerStop.isPlaying()) {
				this.spin = true;
				// window.sm.play({ name: "spin_sfx" });
				// this.tweenerStop = new Tween(this.fg_icon)
				//   .to({ rotation: 1, alpha: 0 }, 50)
				//   .easing(Easing.Sinusoidal.InOut)
				//   .start()
				//   .onComplete(() => {
				this.tweenerStop = new Tween(this.bg_icon)
					.to({ alpha: 1, rotation: 0 }, 50)
					.easing(Easing.Linear.None)
					.start();
				this.animation.gotoAndStop(0);
				this.animation.visible = false;
				// });
			}
		}
	}

	toggleButton(b) {
		this.enabled = b;
	}

	animateDisable() {
		if (!this.tween || !this.tween.isPlaying()) {
			window.sm.play({ name: 'error_sfx' });
			this.tween = new Tween(this.bg)
				.to({ x: 5 }, 50)
				.easing(Easing.Linear.None)
				.yoyo(true)
				.repeat(3);
			this.tween.start();
			this.tween_icon = new Tween(this.bg_icon)
				.to({ x: 5 }, 50)
				.easing(Easing.Linear.None)
				.yoyo(true)
				.repeat(3);
			this.tween_icon.start();
			this.enabled = false;
		}
	}

	getSize() {
		return {
			width: this.bg.width,
			height: this.bg.height
		};
	}
}

export default SpinButton;
